import './index.css';

import { FC } from 'react';

const AppProvider: FC = ({ children }) => <>{children}</>;

export default AppProvider;
